import { render, staticRenderFns } from "./x-info.vue?vue&type=template&id=2e672c84&scoped=true"
import script from "./x-info.vue?vue&type=script&lang=js"
export * from "./x-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e672c84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/bitnami/deploy/oscar_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e672c84')) {
      api.createRecord('2e672c84', component.options)
    } else {
      api.reload('2e672c84', component.options)
    }
    module.hot.accept("./x-info.vue?vue&type=template&id=2e672c84&scoped=true", function () {
      api.rerender('2e672c84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/info_poseurs/x-info.vue"
export default component.exports